import React from 'react';
import './App.css';
import Router from './routes';
import { CssBaseline } from '@mui/material';
import AppTheme from './theme/AppTheme';
import { clearSettings, setPublicSettings } from './store/App';
import { getPublicSettings } from './api/app';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { StoreInterfaces } from './types/store/StoreInterfaces';
import { resetSessionAuth } from './store/Session';
import { getNewQuestionNotifications } from './api/notification/getNewQuestionNotifications';
import { setNotifications } from './store/Notification';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import "moment/locale/pt";
import "moment/locale/es";

export default function App(props: Readonly<{ disableCustomTheme?: boolean }>) {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const currentLanguage = useSelector((state: StoreInterfaces) => state.ui.language);
  const session = useSelector((state: StoreInterfaces) => state.session);

  React.useEffect(() => {
    if (!session.accessToken) return;

    (async () => {
      try {
        const notifications = await getNewQuestionNotifications();
        dispatch(setNotifications(notifications));
      } catch (error) {
        console.error(error);
      }
    })();
  }, [session.accessToken, dispatch]);

  React.useEffect(() => {
    i18n.changeLanguage(currentLanguage);
  }, [currentLanguage, i18n]);

  React.useEffect(() => {
    resetSessionAuth();
  }, []);

  React.useEffect(() => {
    getPublicSettings()
      .then((response) => {
        dispatch(setPublicSettings(response));
      })
      .catch((error) => {
        console.error(error);
      });

    return () => {
      dispatch(clearSettings()); 
    };
  }, [dispatch]);

  return (
    <LocalizationProvider
      dateAdapter={AdapterMoment}
      adapterLocale={currentLanguage.split("-")[0]}
    >
      <AppTheme {...props}>
        <CssBaseline enableColorScheme />
        <Router />
      </AppTheme>
    </LocalizationProvider>
  );
}
